import { render, staticRenderFns } from "./DiagnosticsList.vue?vue&type=template&id=72e9a7e0&scoped=true&"
import script from "./DiagnosticsList.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsList.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticsList.vue?vue&type=style&index=0&id=72e9a7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9a7e0",
  null
  
)

export default component.exports